/**
 * Defines events that can be emitted from the Media Matrix or Site Monitor.
 */
export enum MatrixEvents {
	Reset = "Matrix.Reset",
	Ready = "Matrix.Ready",

	SetEventRegion = "Matrix.SetEventRegion",
	SetEventDetails = "Matrix.SetEventDetails",

	SetEventRegionComplete = "Matrix.SetEventRegion.Complete",
	SetEventDetailsComplete = "Matrix.SetEventDetails.Complete"
}
